export const BinIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 4.5L14.5937 2.3906C14.2228 1.8342 13.5983 1.5 12.9296 1.5H11.0704C10.4017 1.5 9.7772 1.8342 9.40627 2.3906L8 4.5M16 4.5H8M16 4.5H21M8 4.5H3" />
      <rect x="4.5" y="4.5" width="15" height="18" />
      <path d="M14.5789 10.1744V17.0354" />
      <path d="M9.35669 10.1744V17.0354" />
    </svg>
  );
};
